import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { usePermissions } from '@/hooks/use-permissions';

interface CreatePurchaseOrderButtonProps {
  projectId: number;
  projectStatus: string | null | undefined;
  purchasingEnabled: boolean;
}

/** Opens New Purchase Order with this job pre-filled (active jobs only). */
export function CreatePurchaseOrderButton({
  projectId,
  projectStatus,
  purchasingEnabled,
}: CreatePurchaseOrderButtonProps) {
  const { isAdmin, isManager } = usePermissions();
  if (!purchasingEnabled || !(isAdmin || isManager) || projectStatus !== 'active') {
    return null;
  }
  return (
    <Button variant="outline" size="sm" asChild data-testid="project-create-po">
      <Link to={`/purchase-orders/new?project=${projectId}`}>
        <ShoppingCart className="h-4 w-4 mr-1" />
        Create PO
      </Link>
    </Button>
  );
}
